import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Slider from '../components/Slider';
import { initNews } from '../actions/action';

const mapStateToProps = ({ newsEvent }) => {
  // console.log('rest', rest);
  // const newsWP = _.map(newsEvent, value => value);
  // console.log('newsEvent', newsEvent);
  // console.log('newsWP', newsWP);
  // const news = _.reduce(newsWP, (sum, n) => _.concat(sum, n), []);
  return {
    // collection: news,
    collection: newsEvent,
  };
};

const actions = { initNews };

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(actions, dispatch) };
}

class NewsEventReadMore extends Component {
  state = {
    content: {},
    loading: true
  };

  componentDidMount = async () => {
    const { collection, match, language } = this.props;
    if (_.isEmpty(collection)) {
      this.setState({
        loading: true
      });
      await this.fetch();
    } else {
      this.loadNewsEventData(language);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const { match, language } = this.props;
    if (prevProps.match !== match) {
      this.loadNewsEventData(language);
    }
  }

  loadNewsEventData = (language) => {
    const { collection, match } = this.props;
    const slug = _.get(match, 'params.id');
    const currentLanguageCollection = _.get(collection, language, {});
    // console.log('currentLanguageCollection', currentLanguageCollection);
    const content = _.find(
      currentLanguageCollection,
      collec => _.toString(_.get(collec, 'slug')) === _.toString(slug)
    );
    // console.log('content', content);
    this.setState({
      content,
      loading: false
    });
  }

  fetch = () => {
    this.props.actions.initNews();
  };

  render() {
    const { history } = this.props;
    const { content, loading } = this.state;
    const title = _.get(content, ['title', 'rendered']);
    const detail = _.get(content, ['content', 'rendered']);
    const gallery = _.get(content, ['acf', 'gallery']);
    // console.log('gallery', content);
    if (loading) return <div>Loading</div>;

    return (
      <div className="news-readmore">
        <div className="news-content row no-gutters">
          <div className="content-text col-12 order-2 col-lg-4 order-lg-1">
            <div className="content-text-detail">
              <h2
                className="darkGray content-head"
                dangerouslySetInnerHTML={{
                  __html: title
                }}
              />
              <div
                className="content-detail gray"
                dangerouslySetInnerHTML={{
                  __html: detail
                }}
              />
              <button className="back-button" onClick={() => history.goBack()}>
                <i className="icon-arrow-left lightBlue" />
                <h4 className="nav lightBlue">Back</h4>
              </button>
            </div>
          </div>
          <div
            className="content-slider col-12 order-1 col-lg-8 order-lg-2"
          // style={{ height: 900 }}
          >
            <Slider
              className="modal-slider"
              settings={{
                dots: true,
                infinite: true,
                speed: 500,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
              }}
              itemList={gallery}
              uiRenderer={data => (
                <img src={_.get(data, ['url'])} alt="" />
              )}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewsEventReadMore);



// WEBPACK FOOTER //
// ./src/screens/NewsEventReadMore.js